import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconTrendingCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTrendingCircle"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M7.25 14.75L10 12L12 14L16 10" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 9.5H16.5V12.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTrendingCircle;
